import {Button, NumberInput} from "@mantine/core";
import {useState} from "react";
import withRouteErrorBoundary from "../../components/ErrorBoundary/withRouteErrorBoundary.tsx";
import Page from "../../components/Page/Page.tsx";
import {isIOS, negativeInputMode} from "../../utils/Utils.ts";


function TestPage() {
    const [val, setVal] = useState(null);
    const [text, setText] = useState('');


    return (
        <Page>
            <NumberInput value={val} onChange={setVal} inputMode={negativeInputMode} />
            <p>
                Ciao, {isIOS ? 'IOs' : 'altro'}<br /><hr/>
                {JSON.stringify(window.navigator.userAgent)}
            </p>

            <textarea value={text} onChange={e => setText(e.target.value)}></textarea>
            <Button onClick={() => console.log(parseData(text, []))}>Test parse</Button>
        </Page>

    )
}


const parseData = (text, networks) => {
    let update = {};

    let n = text.match(/\n?([\w ]+)\t(Kill|Rescue)/);
    if(n) {
        update.name = n[1];
    }
    let t = text.match(/\t(Kill|Rescue)\n/);
    if(t) {
        update.type = t[1];
    }

    let exp = text.match(/Deadline: Y(\d+)D(\d+)/)
    if(exp) {
        update.expiration_y = exp[1];
        update.expiration_d = exp[2];
    }
    let d = text.match(/Difficulty: (\w+)/);
    if(d) {
        update.difficulty = d[1];
    }
    let r = text.match(/Reward: (\w+)/);
    if(r) {
        update.reward = r[1];
    }

    let net = text.match(/\n([\w\s]+)\tCompleted/);
    if(net) {
        let network = networks.find(el => el.name === net[1]);
        if(network) {
            update.network = network.id;
        }
    }

    return update;
}


export default withRouteErrorBoundary(TestPage);
